import React, { useState } from "react";
import { Button } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrainSubway, faTrain } from "@fortawesome/free-solid-svg-icons";
import { VARIANT_OPTIONS } from "../../constants/login";
import "../../styles/loginStyles.scss";

type Props = {
  onSelect: (variant: string) => void;
  /**
   * Keys from VARIANT_OPTIONS this account may pick, per allowedVariantKeys
   * (config/useRouterVersionConfig). null/undefined means unrestricted —
   * every configured option is offered.
   */
  allowedKeys?: string[] | null;
};

const ICON_MAP: Record<string, any> = {
  trainSubway: faTrainSubway,
  train: faTrain,
};

function VariantSelector({ onSelect, allowedKeys = null }: Props) {
  const restricted = allowedKeys
    ? VARIANT_OPTIONS.filter((opt) => allowedKeys.includes(opt.key))
    : VARIANT_OPTIONS;
  // A restriction that resolves to nothing recognizable (e.g. a typo'd key)
  // falls back to the full list rather than rendering an empty, unusable
  // picker that would strand the user at login with nothing to click.
  const options = restricted.length > 0 ? restricted : VARIANT_OPTIONS;

  const [selected, setSelected] = useState<string>(options[0].key);

  const handleContinue = () => {
    onSelect(selected);
  };

  return (
    <div className="variantSelector__container">
      <p className="loginStyles__homeLogin" style={{ fontSize: "18px", marginBottom: "4px" }}>
        Select Your System
      </p>
      <p style={{ color: "#888", fontSize: "13px", marginBottom: "20px" }}>
        Choose the platform you want to access
      </p>

      {/* CSS grid, not a 2-slot sliding toggle — scales to however many
          options are actually offered instead of assuming exactly 2. */}
      <div className="variantSelector__grid">
        {options.map((opt) => {
          const isActive = selected === opt.key;
          return (
            <button
              key={opt.key}
              type="button"
              className={`variantSelector__option ${
                isActive ? "variantSelector__option--active" : ""
              }`}
              onClick={() => setSelected(opt.key)}
            >
              <FontAwesomeIcon icon={ICON_MAP[opt.icon]} className="variantSelector__icon" />
              <span className="variantSelector__label">{opt.label}</span>
            </button>
          );
        })}
      </div>

      <Button className="buttonStyle__1 mt-4" style={{ width: "100%" }} onClick={handleContinue}>
        Continue
      </Button>
    </div>
  );
}

export default VariantSelector;
